/**
 * @generated SignedSource<<e175ed72c2cc74692401a1facff86327>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksTypeMenuArticleSearchConnection$data = {
  readonly aggregations: {
    readonly articleTypeId: {
      readonly buckets: ReadonlyArray<{
        readonly doc_count: number;
        readonly key: string;
      }>;
    };
    readonly contentType: {
      readonly buckets: ReadonlyArray<{
        readonly doc_count: number;
        readonly key: string;
      }>;
    };
  } | null | undefined;
  readonly " $fragmentType": "hooksTypeMenuArticleSearchConnection";
};
export type hooksTypeMenuArticleSearchConnection$key = {
  readonly " $data"?: hooksTypeMenuArticleSearchConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksTypeMenuArticleSearchConnection">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "hooksTypeMenuArticleSearchConnection"
};

(node as any).hash = "17a68492e4b7eb12ee4b68e4ec1eee3c";

export default node;
